import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Iterativedesignyeppy = () => {
  return (
    <div className="iterativedesign_yeppy p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Iterative Design Process Design Improvement</h2>
            <div className="iterative_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/iterative_design.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={949}
                height={639}
              />
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              The iterative design process for the Yeppy app revolves around the
              continuous refinement of its features, with a sharp focus on the
              most frequently used features. This includes finance (bill
              payments and mobile transactions), retail (comprising grocery and
              healthcare items), and booking services (encompassing events,
              hotels, and flights). In our quest for design perfection, we
              conducted a survey involving 15 users, providing them with the
              prototype to engage with as per their individual preferences. The
              outcomes of this exercise have offered insights into user
              inclinations, revealing:
            </p>
            <ul>
              <li>
                4 users showing a preference for the finance/bill payment
                module.
              </li>
              <li>
                6 users expressing a distinct liking for the retail and grocery
                module.
              </li>
              <li>
                5 users actively using the booking module for flight or hotel
                reservations.
              </li>
            </ul>
            <p>
              In light of these findings, we have undertaken a strategic
              optimization of the app's design to enhance user accessibility,
              making it even more intuitive and accommodating to their specific
              needs. We placed the modules as per the feedback given by the
              users to make it more customer-centric.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Iterativedesignyeppy;
